import { Route } from "@angular/router";

/** Guest-only authentication routes. Self-service administrator signup is intentionally absent. */
export const publicAuthRoutes: Route[] = [
  {
    path: "confirmation-required",
    loadChildren: () =>
      import(
        "app/modules/auth/confirmation-required/confirmation-required.routes"
      ),
  },
  {
    path: "accept-team-invitation",
    loadChildren: () =>
      import(
        "app/modules/auth/accept-team-invitation/accept-team-invitation.routes"
      ),
  },
  {
    path: "forgot-password",
    loadChildren: () =>
      import("app/modules/auth/forgot-password/forgot-password.routes"),
  },
  {
    path: "reset-password",
    loadChildren: () =>
      import("app/modules/auth/reset-password/reset-password.routes"),
  },
  {
    path: "sign-in",
    loadChildren: () => import("app/modules/auth/sign-in/sign-in.routes"),
  },
  {
    path: "oauth-callback",
    loadChildren: () =>
      import("app/modules/auth/oauth-callback/oauth-callback.routes"),
  },
];
